import { createRoot } from 'react-dom/client';
import React from 'react';

export interface OpenPopoutOptions {
  name?: string;
  features?: string;
  title?: string;
  containerId?: string;
}

export async function openPopout(options: OpenPopoutOptions, element: React.ReactElement) {
  const features = options.features ?? '';
  const name = options.name ?? 'popout_default';
  const child = window.open('', name, features);
  if (!child) throw new Error('POPUP_BLOCKED');

  try {
    child.document.title = options.title || '';
    const container = child.document.createElement('div');
    const containerId = options.containerId ?? `realtime-popout-root-${name}`;
    container.id = containerId;
    child.document.body.appendChild(container);

    // Clone stylesheets and inline <style> to child head. Failures (CORS, etc.) are non-fatal.
    Array.from(document.querySelectorAll('link[rel="stylesheet"], style')).forEach((node) => {
      try {
        child.document.head.appendChild(node.cloneNode(true));
      } catch (e) {
        // ignore clone errors (CORS or dynamic styles)
      }
    });

    const root = createRoot(container);
    root.render(element);

    // detect manual close and cleanup reference via onunload
    child.addEventListener('beforeunload', () => {
      try {
        root.unmount();
      } catch (e) {
        // ignore
      }
    });

    return { child, root };
  } catch (err) {
    if (child && !child.closed) child.close();
    throw err;
  }
}

export function closePopout(root: any, child?: Window | null) {
  try {
    if (root) {
      root.unmount();
    }
    
    if (child && !child.closed) {
      child.close();
    }
    
    // Força o foco de volta para a janela principal
    if (window.parent) {
      window.parent.focus();
    } else {
      window.focus();
    }
    
  } catch (e) {
    // ignore
  }
}
